import axios from "axios";

export const validateOtp = async (data) => {
    let {token, ...payload} = data
    let res = await axios.post('/auth/validate_otp', payload, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return res.data;
}

export const setPassword = async (data) => {
    let {token, ...payload} = data
    let res = await axios.post('/auth/set_password', payload, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return res.data;
}

export const signIn = async (data) => {
    let res = await axios.post('/auth/login', data)
    return res.data;
}

export const ssoAuthent = async (data) => {
    let {uuid, ...payload} = data
    let res = await axios.post(`/auth/sso-callback?uuid=${uuid}`, payload)
    return res.data;
}

export const forgotPassword = async (data) => {
    let res = await axios.post('/auth/forgot_password', data)
    return res.data;
}

export const verifyResetOtp = async (data) => {
    let {email, ...payload} = data
    let res = await axios.post(`/auth/verify_reset_password_otp/${email}`, payload)
    return res.data;
}


export const register2fa = async (token) => {
    let res = await axios.get('/auth/register_2fa', {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return res.data;
}

export const verify2FaToken = async (data) => {
    let {auth_token, ...payload} = data
    let res = await axios.post('/auth/verify_2fa_token', payload, {
        headers: {
            'Authorization': `Bearer ${auth_token}`
        }
    })
    return res.data;
}

export const loginWithGoogle = async (idToken) => {
    let res = await axios.post('/auth/login_with_google', {id_token: idToken})
    return res.data;
}
